export default "__VITE_ASSET__OI5v$gRH__"